export const environment = {
  ssr: false,
  brandName: 'Groupbenefitz',
  app: {
    production: false,
    grp: "https://testapi.groupbenefitz.aitestpro.com/",
    globalgrp: "https://test.groupbenefitz.aitestpro.com/",
    logourl: 'https://testadminapi.groupbenefitz.aitestpro.com/api/ap/',
    commonurl: 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/',
    acceptJsUrl: 'https://jstest.authorize.net/v1/Accept.js',
    waddellink: 'https://test.groupbenefitz.aitestpro.com/waddell/',
    langApi: 'https://languageengineapi.aitestpro.com/',
    iafglink: 'https://test.groupbenefitz.aitestpro.com/iafg/',
    kixcare: 'https://test.groupbenefitz.aitestpro.com/kixcare/',
    memberPortal: 'https://members.groupbenefitz.aitestpro.com/',
    corporatePortal: 'testcorporate.groupbenefitz.aitestpro.com',
    adminPortal: 'https://testadminapi.groupbenefitz.aitestpro.com',
    authorizePortal: 'https://igbmspaymentstest.aitestpro.com/',
    authorizeNet: true, // make it to true after setup for new apis subscription and registration have handled
    // Sends uSession — a per-tab provisional id for whoever opened the signup —
    // in the analytics, transactions, validation, registration and subscription
    // payloads. Opt-in: anything other than true sends nothing.
    // See docs/usession.md.
    sendUSession: true,
    // Signup progress tracking. Opt-in: anything other than true is off.
    // Leave OFF in deployed environments until the transaction api upserts
    // on (reference, process) — until then each post inserts a new row.
    //   trackSignupProgress  posts the step-1 form as it is filled in
    // See docs/signup-progress-tracking.md.
    trackSignupProgress: false,
    clientKey: '75633q5Q9yM5uxzZWEd65Fh9NjJwHY6M6kEH5WXxMuZc5qARcH76g62NtzS85N8a',
    apiLoginID: '3Sk9Zd6A28',
    personalInfoCaptcha: '6Lfj88QgAAAAAAJ8bY1NW0Bgmm9V8PV2onC4RCNx',
    fusbillrecaptcha: '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11',

    localgrp: 'https://localhost:4001/',
    atp: 'https://dev.aitestpro.com/',

    id: 'fooClientId',
    key: 'secret',
  },

  googleMapKey: 'AIzaSyCx_ZaqWDu6leZ7ffeIz5sG9qrN5s4KFF0',
  debugEnabled: true,
};
